import { useEffect, useState } from 'react';

import _ from 'lodash';

import { useRouter } from 'next/router';

import moment from 'moment';

import getSlug from 'speakingurl';

import Link from 'next/link';

import PropTypes from 'prop-types';

import Label from '../shared/apartment-type-label.component';

import { FadeInAnimation, ProgressiveImage, Image } from '../shared';

const RoomTypeCard = (props) => {

    const { roomType, noFade, allPortfolios, selectedRoomPortfolio  } = props;
    
    const {
        id,
        images,
        description,
        buildingAddress,
        startingPrice,
        billingModelDescription,
        maxGuests,
        arrangementType,
        soonestAvailable,
        gender,
        sharedLivingSpace,
        buildingName,
        renewalDuration,
        numberAvailable,
        acceptingProvisionalBookings,
        thumbnails,
        portfolioId,
    } = roomType;   

    const numberAvailableForMales = _.get(roomType, 'numberAvailableForMales');

    const numberAvailableForFemales = _.get(roomType, 'numberAvailableForFemales');    

    const router = useRouter();

    const startDate = moment(_.get(router, 'query.startDate')).format('YYYY-MM-DD');

    const endDate = moment(_.get(router, 'query.endDate')).format('YYYY-MM-DD');

    const urlFriendlyDescription = getSlug(description);

    const [portfolio, setPortfolio] = useState({
        image: _.get(selectedRoomPortfolio, 'images[0]', ''),
        name: _.get(selectedRoomPortfolio, 'name', ''),
    });

    let potfolioID = portfolioId ? portfolioId : _.get(roomType, 'ids[0].portfolioId');    

    useEffect(() => {
        _.map(allPortfolios, (portfolio) => {
            if (portfolio.id === potfolioID) {
                setPortfolio({
                    image: _.get(portfolio, 'images[0]'),
                    name: _.get(portfolio, 'name'),
                });
            }
        });
    }, [allPortfolios, potfolioID]);

    const portfolioHasLogo = _.get(portfolio, 'image') ? true : false;
    
    let isAvailable = true;

    let labelText = '';

    let href = `/room/${urlFriendlyDescription}/${_.get(
        roomType,
        'id',
    )}?startDate=${startDate}&endDate=${endDate}`;

    if (
        (numberAvailableForMales === 0 && gender === 'male') ||
        (numberAvailableForFemales === 0 && gender === 'female') ||
        numberAvailable === 0 ||
        (renewalDuration === 'Daily' && moment(startDate) < moment(soonestAvailable))
    ) {
        isAvailable = false;
    }

    if (arrangementType === 'Shared') {
        if (gender === 'male') {
            href = `/room/${urlFriendlyDescription}/${id}?gender=${gender}`;
            labelText = 'Shared-Male';
        } else if (gender === 'female') {
            const femaleId = id.replace('___female', '');
            href = `/room/${urlFriendlyDescription}/${femaleId}?gender=${gender}`;
            labelText = 'Shared-Female';
        }
    } else if (arrangementType === 'Private') {
        if (sharedLivingSpace) {
            labelText = 'Private Bedroom';
        } else {
            labelText = 'Private Apartment';
        }
    }

    const renderLabels = () => {
        const limit = 3;
        if (!isAvailable) {
            return (
                <div className='room-type-card-label-container'>
                    <Label type="green">Waiting List</Label>
                </div>
            );
        }
        if (acceptingProvisionalBookings) {
            return (
                <div className='room-type-card-label-container'>
                    <Label type="green">New Room</Label>
                </div>
            );
        }
        if (numberAvailable <= limit) {
            return (
                <div className='room-type-card-label-container'>
                    <Label>Only ${numberAvailable} left </Label>
                </div>
            );
        }
        if (isAvailable && numberAvailableForMales <= limit && gender === 'male') {
            return (
                <div className='room-type-card-label-container'>
                    <Label>Only ${numberAvailableForMales} left </Label>
                </div>
            );
        }
        if (isAvailable && numberAvailableForFemales <= limit && gender === 'female') {
            return (
                <div className='room-type-card-label-container'>
                    <Label>Only ${numberAvailableForFemales} left </Label>
                </div>
            );
        }
        return null;
    };

    const renderCard = () => {

        const portfolioImageSrc =
            _.get(portfolio, 'name') === 'HOMii'
                ? '/assets/images/homii_logo.png'
                : _.get(portfolio, 'image');
                
        const portfolioImageHeight = _.get(portfolio, 'name') === 'HOMii' ? 13 : 20;

        let imageSrc = _.get(images, '[0]');      

        return (

            <div className='room-type-card-container' id={id}>

                <ProgressiveImage
                    greyScale={!isAvailable}
                    alt="Room"
                    width="100%"
                    height={262}
                    className="room-type-card-image card-image"
                    animate
                    thumbnailSrc={_.get(thumbnails, '[0]')}
                    src={imageSrc}
                    speed={0.95}
                />

                {renderLabels()}

                <div className='room-type-card-description-container'>

                    <p className='room-type-card-room-type-paragraph'>{description}</p>

                    <Label className='room-type-card-label' small={true} type="white">
                        {labelText}
                    </Label>

                </div>

                <div className='room-type-card-caption-container'>

                    <p className='room-type-card-caption'>
                        {buildingName}
                        {', '}
                        {_.get(buildingAddress, 'addressLine2')}
                    </p>

                    <p className='room-type-card-caption-grey'>Sleeps {maxGuests}</p>

                </div>
                
                <p className='room-type-card-caption'>
                    From{' '}
                    <strong>
                        R{startingPrice} {billingModelDescription}
                    </strong>
                </p>

                <div className='room-type-card-caption-container'>

                    <p className='room-type-card-caption'>
                        Managed by <strong>{!portfolioHasLogo && _.get(portfolio, 'name')}</strong>
                    </p>

                    {portfolioHasLogo && (
                        <Image
                            id="portfolio_logo"
                            src={portfolioImageSrc}
                            alt="portfolio logo"
                            height={portfolioImageHeight}
                            isOldImage
                        />
                    )}

                </div>

            </div>
        );
    };

    return (

        <>

            {/* <a className='room-type-card-anchor-tag ' target="_blank">

                {noFade && renderCard()}

                {!noFade && <FadeInAnimation>{renderCard()}</FadeInAnimation>}

            </a> */}

            <Link href={href} as={href} target="_blank" className='room-type-card-anchor-tag'>

                {noFade && renderCard()}

                {!noFade && <FadeInAnimation>{renderCard()}</FadeInAnimation>}
                
            </Link>            

        </>

    );
};

export default RoomTypeCard;

RoomTypeCard.propTypes = {
    noFade: PropTypes.bool,
    roomType: PropTypes.object,
    selectedRoomPortfolio: PropTypes.object,
    allPortfolios: PropTypes.arrayOf(PropTypes.object),
};

